import axios from "axios";

export const listVideos = (cursor, limit, success, failure) => {
    let url = "/api/v1/video/list?limit=" + limit;

    if (cursor) {
        url += "&cursor=" + cursor;
    }

    axios.get(url)
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const createVideo = (video, success, failure) => {
    const url = "/api/v1/video/";

    axios.post(url, {
        title: video.title,
        youTubeId: video.youTubeId,
        ranks: video.ranks,
        order: video.order,
    })
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const saveVideo = (videoId, video, success, failure) => {
    const url = `/api/v1/video/${videoId}/`;

    axios.put(url, {
        title: video.title,
        youTubeId: video.youTubeId,
        ranks: video.ranks,
        order: video.order,
    })
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};
